import { useParams } from 'react-router-dom';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';

// AIDEV-NOTE: True during the window after a teacher switches student via the URL-driven
// Classroom/Student filters but before the GradingHooks effect writes the new student's data
// to the store. Two ways this can happen:
//  1. The student dropdown only navigates — `student` in the store lags the URL; compare URL
//     studentId against store student.id.
//  2. The student dropdown / nav arrows update `student` synchronously so the dropdown label
//     flips instantly, but null out `questionAnswers`/`submission` so the body still skeletons.
//     Compare those against null.
// Returns false during the initial page load (page-level isLoading covers that case).
const useIsStudentTransitioning = (): boolean => {
  const { studentId } = useParams();
  const student = useGradingStore(state => state.student);
  const questionAnswers = useGradingStore(state => state.questionAnswers);
  const submission = useGradingStore(state => state.submission);

  if (student == null) return false;
  if (student.id.toString() !== studentId) return true;

  return questionAnswers == null || submission == null;
};

export default useIsStudentTransitioning;
